














































































































































import Vue from "vue";
import app from "../../../../App.vue"
import Bus from '../../common/bus'
import { isLogin } from "../../common/common";
import { loginWithFB, roteInfo,roteJoin } from "../../common/api";

declare var CONFIG: Object;
declare var FB: any;

export default Vue.extend({
  name: "DialogTip",
  props: {
    InstatceShowDialog: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: "提示信息"
    },
  },
  data() {
    return {
      txt: CONFIG,
      toastName: "",
      rewardName: "",
      userCdkeys: "",
      rewardIcon: "",
      toastHide: true,
      showDialog: false,
      isFb: false,
      rewardArr: [],
      luckyArr: [],
      // 
      userPhone:'',
      egPhone: "0912345678",

    };
  },
  watch: {
    rewardArr(newValue, oldValue) {
      this.rewardIcon =
        "rewardIcon" +
        CONFIG["data"].rewardId.rotate.indexOf(newValue[0].rewardId);
      this.userCdkeys = newValue[0].cdKeys;
      this.rewardName = newValue[0].rewardName;
    }
  },
  methods: {
    close() {
      this.showDialog = false;
    },
    open() {
      this.showDialog = true;
    },
    //手机号输入验证
    inputPhone() {
      if (this.userPhone.length == 1) {
        this.userPhone = this.userPhone.replace(/[^0-9]/g, "");
      } else {
        this.userPhone = this.userPhone.replace(/\D/g, "");
      }
    },
    // 获得焦点
    inputFocus() {
      if(!isLogin()){
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].code_300, true);
        return;
      }
      this.egPhone = "";
    },
    // 失去焦点
    inputBlur() {
      if (!this.userPhone) {
        this.egPhone = "0912345678";
      }
    },
    //发送手机号
    async reserveBtn() {
      var testphone = /^[0-9]*$/;
      if (!this.userPhone) {
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].phone_null);
        return;
      } else if (this.userPhone.length < 10) {
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].phone_null);
        this.userPhone = "";
        return;
      } else {
        let phone = "084" + "-" + this.userPhone;
        // 存储手机号
        let reservePhone = "phone,"+phone;
        await roteJoin(reservePhone);
        this.showDialog = false;
        // let data: any = await reserveJoin(phone);
        // if (data && data.code == 200) {
        //   // reserver pixel
        //   Pixel.instance.pixel("button");
        //   let number: any = Number(this.reservePerson);
        //   this.reservePerson = (number + 1).toString();
        //   if (isLogin()) {
        //     Vue.prototype.$dialog.show(
        //       "tip",
        //       CONFIG["tip"].reserve_success_login
        //     );
        //     return;
        //   }
        //   Vue.prototype.$dialog.show(
        //     "tip",
        //     CONFIG["tip"].reserve_success,
        //     true
        //   );
          

        // } else if (data && data.code == 1005) {
        //   Vue.prototype.$dialog.show("tip", CONFIG["tip"].code_1005);
    //     } else {
    //       this.userPhone = "";
    //     }
      }
    },
    // fbcebook登录
    async facebook() {
      let that = this;
      FB.getLoginStatus(function(response) {
        if (response.status === "connected") {
          that.FBSdkLogin(response.authResponse.accessToken);
        } else {
          FB.login(function(response) {
            if (response.status === "connected") {
              // Logged into your app and Facebook.
              that.FBSdkLogin(response.authResponse.accessToken);
            } else {
              // The person is not logged into this app or we are unable to tell.
            }
          });
        }
      });
    },
    async FBSdkLogin(token) {
      let data: any = await loginWithFB(token);
      if (data && data.code == 200) {
        localStorage.setItem("token", data.state.token);
        let myTimer: any = new Date().getTime().toString();
        localStorage.setItem("activetime", myTimer);
        // location.reload();
        Bus.$emit('loginSuccess', true);   
      }
    }
  }
});
